import React, { useContext, useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  // useCustomerSignupMutation, // OLD email/password signup - replaced by combined login/signup OTP
  // useCheckEmailAlreadyExistedMutation, // OLD email/password signup - replaced by combined login/signup OTP
  // useSendOtpMutation, // OLD login-only OTP - replaced by combined auth/send-otp
  // useVerifyOtpMutation, // OLD login-only OTP - replaced by combined auth/verify-otp
  // useSignupSendOtpMutation, // OLD mobile-only signup OTP - replaced by combined auth/send-otp
  // useSignupVerifyOtpMutation, // OLD mobile-only signup OTP - replaced by combined auth/verify-otp
  useAuthSendOtpMutation,
  useAuthVerifyOtpMutation,
} from '../services/customerApi';
// import { Eye, EyeOff } from 'lucide-react'; // OLD email/password signup - replaced by mobile OTP signup
import { useAddCartdetailsMutation, useLazyGetCardDetailsByUseridQuery } from '../services/cartApi';
import { CartContext } from './CartContext';
import { toast } from 'react-toastify';

const RESEND_SECONDS = 30;

const Account = () => {
  const navigate = useNavigate();
  const [addCartFn] = useAddCartdetailsMutation();
  const { setCart } = useContext(CartContext);
  const [getAllCartDetailsFn] = useLazyGetCardDetailsByUseridQuery();

  // ---- OLD email/password signup state (commented out, replaced by mobile OTP signup) ----
  // const [formData, setFormData] = useState({
  //   username: '',
  //   first_name: '',
  //   last_name: '',
  //   email_id: '',
  //   mobile: '',
  //   password: '',
  //   confirmPassword: '',
  //   location: '',
  // });
  // const [passwordVisible, setPasswordVisible] = useState(false);
  // const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  // const [emailExists, setEmailExists] = useState(false);
  // const [signup] = useCustomerSignupMutation();
  // const [checkEmailAlreadyExisted] = useCheckEmailAlreadyExistedMutation();

  // ---- Combined Login/Signup OTP state (single identifier: mobile, email, or username) ----
  const [loginIdentifier, setLoginIdentifier] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']); // 6-digit OTP
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const otpInputRefs = useRef([]);

  // ---- OLD separate Signup OTP state (commented out, replaced by combined login/signup above) ----
  // const [signupMobile, setSignupMobile] = useState('');
  // const [signupOtp, setSignupOtp] = useState(['', '', '', '', '', '']);
  // const [signupOtpSent, setSignupOtpSent] = useState(false);
  // const [signupResendTimer, setSignupResendTimer] = useState(0);
  // const signupOtpInputRefs = useRef([]);

  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(null);

  const [authSendOtp, { isLoading: sendingOtp }] = useAuthSendOtpMutation();
  const [authVerifyOtp, { isLoading: verifyingOtp }] = useAuthVerifyOtpMutation();

  // ---- Resend timer countdown ----
  useEffect(() => {
    if (resendTimer <= 0) return;
    const t = setTimeout(() => setResendTimer((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [resendTimer]);

  // ---- OLD email/password signup handlers (commented out, replaced by mobile OTP signup) ----
  // const handleChange = (e) => {
  //   const { id, value } = e.target;
  //   setFormData({ ...formData, [id]: value });
  // };
  //
  // const handleEmailBlur = async () => {
  //   if (!formData.email_id) return;
  //   try {
  //     const res = await checkEmailAlreadyExisted({ email_id: formData.email_id }).unwrap();
  //     if (res.status === 'failed') {
  //       setEmailExists(true);
  //       setMessage('Email already exists.');
  //       setSuccess(false);
  //     } else {
  //       setEmailExists(false);
  //       setMessage('');
  //     }
  //   } catch (err) {
  //     toast.error('Error checking email.');
  //   }
  // };

  const syncCart = async (customerId) => {
    const localCart = JSON.parse(localStorage.getItem('cart')) || [];

    for (const item of localCart) {
      try {
        await addCartFn({
          user_id: customerId,
          product_id: item.product_id,
          unit_id: item.unit_id,
          quantity: item.quantity || 1,
        }).unwrap();
      } catch (err) {
        console.error('Error syncing cart item:', item, err);
      }
    }

    localStorage.removeItem('cart');
  };

  // ---- OLD email/password signup handler (commented out, replaced by mobile OTP signup) ----
  // const handleRegister = async (e) => {
  //   e.preventDefault();
  //
  //   if (emailExists) {
  //     setMessage('Email already registered.');
  //     setSuccess(false);
  //     return;
  //   }
  //
  //   if (formData.password !== formData.confirmPassword) {
  //     setMessage('Passwords do not match.');
  //     setSuccess(false);
  //     return;
  //   }
  //
  //   try {
  //     await signup(formData).unwrap();
  //     toast.success('Registration successful! Please check your email to verify.');
  //     setMessage('Registration successful! Please check your email to verify.');
  //     setSuccess(true);
  //     setFormData({
  //       username: '',
  //       first_name: '',
  //       last_name: '',
  //       email_id: '',
  //       mobile: '',
  //       password: '',
  //       confirmPassword: '',
  //       location: '',
  //     });
  //   } catch (err) {
  //     setMessage('Registration failed. Please try again.');
  //     setSuccess(false);
  //   }
  // };

  // ---- OLD separate Mobile OTP Signup handlers (commented out, replaced by combined login/signup below) ----
  // const handleSignupSendOtp = async (e) => { ... };
  // const handleSignupResendOtp = async () => { ... };
  // const handleChangeSignupMobile = () => { ... };
  // const handleSignupOtpDigitChange = (index, value) => { ... };
  // const handleSignupOtpKeyDown = (index, e) => { ... };
  // const handleSignupOtpPaste = (e) => { ... };
  // const handleSignupVerifyOtp = async (e) => { ... };

  // Detect whether the entered identifier is an email, a 10-digit mobile number, or a username
  const buildIdentifierPayload = () => {
    const value = loginIdentifier.trim();
    if (value.includes('@')) {
      return { email_id: value };
    } else if (value.length === 10 && !isNaN(value)) {
      return { mobile: value };
    }
    return { username: value };
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!loginIdentifier.trim()) {
      setMessage('Please enter your username, email, or mobile number.');
      setSuccess(false);
      return;
    }

    try {
      const payload = buildIdentifierPayload();
      const res = await authSendOtp(payload).unwrap();

      if (res.status !== 'success') {
        throw new Error(res.message || 'Failed to send OTP');
      }

      setOtpSent(true);
      setOtp(['', '', '', '', '', '']);
      setResendTimer(RESEND_SECONDS);
      setMessage('OTP sent successfully.');
      setSuccess(true);
      toast.success('OTP sent! Please check your email/mobile.');

      setTimeout(() => otpInputRefs.current[0]?.focus(), 100);
    } catch (err) {
      const errorMsg = err?.data?.message || err.message || 'Failed to send OTP';
      setMessage(errorMsg);
      setSuccess(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0) return;
    await handleSendOtp({ preventDefault: () => {} });
  };

  const handleChangeIdentifier = () => {
    setOtpSent(false);
    setOtp(['', '', '', '', '', '']);
    setResendTimer(0);
    setMessage('');
    setSuccess(null);
  };

  const handleOtpDigitChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // digits only
    const digit = value.slice(-1);
    const nextOtp = [...otp];
    nextOtp[index] = digit;
    setOtp(nextOtp);

    if (digit && index < otp.length - 1) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, otp.length);
    if (!pasted) return;
    e.preventDefault();
    const nextOtp = [...otp];
    for (let i = 0; i < pasted.length; i++) nextOtp[i] = pasted[i];
    setOtp(nextOtp);
    otpInputRefs.current[Math.min(pasted.length, otp.length - 1)]?.focus();
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    const code = otp.join('');
    if (code.length !== otp.length) {
      setMessage('Please enter the complete OTP.');
      setSuccess(false);
      return;
    }

    try {
      const payload = { ...buildIdentifierPayload(), otp: code };
      const res = await authVerifyOtp(payload).unwrap();

      if (res.status !== 'success') {
        throw new Error(res.message || 'Invalid OTP');
      }

      const customerId = res.customer?.customer_id || res.customer_id;
      if (!customerId) {
        throw new Error('customer_id missing in response');
      }

      localStorage.setItem('token', res.token);
      localStorage.setItem('customer_id', customerId);
      if (res.username) {
        localStorage.setItem('username', res.username);
      }

      await syncCart(customerId);

      try {
        const cartResponse = await getAllCartDetailsFn(customerId).unwrap();
        if (cartResponse?.data) {
          setCart(cartResponse.data);
        }
      } catch (err) {
        console.error('Cart fetch failed:', err);
      }

      const successMessage = res.action === 'signup' ? 'Registration successful! You are now logged in.' : 'Login successful!';
      toast.success(successMessage);
      setMessage(successMessage);
      setSuccess(true);
      setLoginIdentifier('');
      setOtp(['', '', '', '', '', '']);
      setOtpSent(false);

      // Ignore res.redirect_url (backend returns the production domain) - navigate within the SPA instead
      setTimeout(() => navigate('/'), 500);
    } catch (err) {
      console.error('OTP verify error:', err);
      const errorMsg = err?.data?.message || err.message || 'Invalid OTP. Please try again.';
      setMessage(errorMsg);
      setSuccess(false);
    }
  };

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {message && !success && (
            <div className="alert alert-danger">{message}</div>
          )}

          {/* Login / Signup Form (combined OTP based) */}
          <div className="col-xl-6 pe-xl-5">
            <form onSubmit={otpSent ? handleVerifyOtp : handleSendOtp}>
              <div className="border border-gray-100 rounded-16 px-24 py-40 h-100">
                <h6 className="text-xl mb-32">Login / Signup</h6>

                {!otpSent ? (
                  <>
                    <div className="mb-24">
                      <label htmlFor="usernameOrEmail" className="text-lg mb-8 fw-medium">
                        Username or Email or Mobile<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="common-input"
                        id="usernameOrEmail"
                        placeholder="Enter Username or Email or Mobile Number"
                        value={loginIdentifier}
                        onChange={(e) => setLoginIdentifier(e.target.value)}
                      />
                    </div>

                    <div className="mb-24 mt-48 d-flex justify-content-between align-items-center">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                        disabled={sendingOtp}
                      >
                        {sendingOtp ? 'Sending OTP...' : 'Send OTP'}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-16">
                      <p className="text-md text-gray-600 mb-0">
                        Enter the 6-digit code sent to{' '}
                        <span className="fw-semibold text-neutral-900">{loginIdentifier}</span>
                      </p>
                      <button
                        type="button"
                        className="btn-link text-danger-600 fw-semibold p-0 mt-4"
                        style={{ background: 'none', border: 'none' }}
                        onClick={handleChangeIdentifier}
                      >
                        Change
                      </button>
                    </div>

                    <div className="mb-24">
                      <label className="text-lg mb-8 fw-medium d-block">
                        Enter OTP<span className="text-danger">*</span>
                      </label>
                      <div className="d-flex gap-8" onPaste={handleOtpPaste}>
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (otpInputRefs.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="common-input text-center"
                            style={{ width: '48px', height: '48px', padding: 0, fontSize: '20px' }}
                            value={digit}
                            onChange={(e) => handleOtpDigitChange(index, e.target.value)}
                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="mb-24 mt-48 d-flex justify-content-between align-items-center">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                        disabled={verifyingOtp}
                      >
                        {verifyingOtp ? 'Verifying...' : 'Verify & Log in'}
                      </button>

                      <button
                        type="button"
                        className="btn-link text-danger-600 fw-semibold p-0"
                        style={{ background: 'none', border: 'none' }}
                        onClick={handleResendOtp}
                        disabled={resendTimer > 0 || sendingOtp}
                      >
                        {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
                      </button>
                    </div>
                  </>
                )}
                <div className="mt-48">
                  <Link to="/forgotpassword" className="text-danger-600 fw-semibold">
                    Forgot your password?
                  </Link>
                </div>
              </div>
            </form>

          </div>

          {/* OLD Register Form (email/password) - commented out, replaced by mobile OTP signup below
          <div className="col-xl-6">
            <form onSubmit={handleRegister}>
              <div className="border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="text-xl mb-32">Register</h6>

                {['username', 'first_name', 'last_name', 'email_id', 'mobile'].map((field, idx) => (
                  <div className="mb-24" key={idx}>
                    <label htmlFor={field} className="text-lg mb-8 fw-medium">
                      {field.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())}
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="common-input"
                      id={field}
                      placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                      value={formData[field]}
                      onChange={handleChange}
                      onBlur={field === 'email_id' ? handleEmailBlur : undefined}
                    />
                  </div>
                ))}

                <div className="mb-24">
                  <label htmlFor="password" className="text-lg mb-8 fw-medium">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      className="common-input"
                      id="password"
                      placeholder="Enter Password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y me-16 cursor-pointer"
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                      {passwordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                    </span>
                  </div>
                </div>

                <div className="mb-24">
                  <label htmlFor="confirmPassword" className="text-lg mb-8 fw-medium">
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type={confirmPasswordVisible ? 'text' : 'password'}
                      className="common-input"
                      id="confirmPassword"
                      placeholder="Confirm Password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                    />
                    <span
                      className="position-absolute top-50 end-0 translate-middle-y me-16 cursor-pointer"
                      onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                    >
                      {confirmPasswordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                    </span>
                  </div>
                </div>

                <div className="mb-24">
                  <label className="text-lg mb-8 fw-medium">
                    Location <span className="text-danger">*</span>
                  </label>
                  <select
                    id="location"
                    className="form-select common-input"
                    value={formData.location}
                    onChange={handleChange}
                  >
                    <option value="">Select Location</option>
                    <option value="Balangar">Balangar</option>
                    <option value="Chintal">Chintal</option>
                    <option value="Jagdigirigutta">Jagdigirigutta</option>
                    <option value="Pragathi Nagar">Pragathi Nagar</option>
                    <option value="Jeedimetla">Jeedimetla</option>
                    <option value="Suchitra">Suchitra</option>
                    <option value="Shapur">Shapur</option>
                    <option value="Gandi Misamma">Gandi Misamma</option>
                    <option value="Kompally">Kompally</option>
                  </select>
                </div>

                <div className="mt-24">
                  <button type="submit" className="btn btn-main w-100 py-18">
                    Register
                  </button>
                </div>
              </div>
            </form>
          </div>
          */}

          {/* OLD separate Register Form (Mobile OTP based) - commented out, replaced by combined Login/Signup above
          <div className="col-xl-6">
            <form onSubmit={signupOtpSent ? handleSignupVerifyOtp : handleSignupSendOtp}>
              <div className="border border-gray-100 rounded-16 px-24 py-40 h-100">
                <h6 className="text-xl mb-32">Register with Mobile Number</h6>

                {!signupOtpSent ? (
                  <>
                    <div className="mb-24">
                      <label htmlFor="signupMobile" className="text-lg mb-8 fw-medium">
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="common-input"
                        id="signupMobile"
                        placeholder="Enter 10-digit mobile number"
                        maxLength={10}
                        value={signupMobile}
                        onChange={(e) => setSignupMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                      />
                    </div>

                    <div className="mb-24 mt-48 d-flex justify-content-between align-items-center">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                        disabled={sendingSignupOtp}
                      >
                        {sendingSignupOtp ? 'Sending OTP...' : 'Send OTP'}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-16">
                      <p className="text-md text-gray-600 mb-0">
                        Enter the 6-digit code sent to{' '}
                        <span className="fw-semibold text-neutral-900">{signupMobile}</span>
                      </p>
                      <button
                        type="button"
                        className="btn-link text-danger-600 fw-semibold p-0 mt-4"
                        style={{ background: 'none', border: 'none' }}
                        onClick={handleChangeSignupMobile}
                      >
                        Change
                      </button>
                    </div>

                    <div className="mb-24">
                      <label className="text-lg mb-8 fw-medium d-block">
                        Enter OTP<span className="text-danger">*</span>
                      </label>
                      <div className="d-flex gap-8" onPaste={handleSignupOtpPaste}>
                        {signupOtp.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (signupOtpInputRefs.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="common-input text-center"
                            style={{ width: '48px', height: '48px', padding: 0, fontSize: '20px' }}
                            value={digit}
                            onChange={(e) => handleSignupOtpDigitChange(index, e.target.value)}
                            onKeyDown={(e) => handleSignupOtpKeyDown(index, e)}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="mb-24 mt-48 d-flex justify-content-between align-items-center">
                      <button
                        type="submit"
                        className="btn btn-main py-18 px-40"
                        disabled={verifyingSignupOtp}
                      >
                        {verifyingSignupOtp ? 'Verifying...' : 'Verify & Register'}
                      </button>

                      <button
                        type="button"
                        className="btn-link text-danger-600 fw-semibold p-0"
                        style={{ background: 'none', border: 'none' }}
                        onClick={handleSignupResendOtp}
                        disabled={signupResendTimer > 0 || sendingSignupOtp}
                      >
                        {signupResendTimer > 0 ? `Resend OTP in ${signupResendTimer}s` : 'Resend OTP'}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
          */}

          {/* Banner (replaces the old Register panel) */}
          <div className="col-xl-6">
            <div className="border border-gray-100 rounded-16 h-100 overflow-hidden">
              <img
                src="/assets/images/banners/mainbanner.jpg"
                alt="Aswika Super Market"
                className="w-100 h-100 object-fit-cover"
              />
            </div>
          </div>
        </div>

        {message && (
          <div className={`alert mt-4 ${success ? 'alert-success' : 'alert-danger'}`}>
            {message}
          </div>
        )}
      </div>
    </section>
  );
};

export default Account;